import React from 'react';

import {IntlShape} from 'react-intl';
import BaselinePDFSummaryPhase from './BaselinePDFSummaryPhase';
import {BaselinePDFPhaseType} from './BaselinePDFTypes';
import {TextHeaderSecondary, TextMain, TextTotal, ViewLine, ViewSection} from './layout/PDFLayout';

type BaselinePDFSummaryProps = {
	phases?: BaselinePDFPhaseType[];
	projectTotal: string;
	intl: IntlShape;
};

const BaselinePDFSummary = ({phases, projectTotal, intl: {formatMessage}}: BaselinePDFSummaryProps): JSX.Element => {
	return (
		<ViewSection style={{backgroundColor: '#E5F4FF'}}>
			<TextHeaderSecondary>{formatMessage({id: 'baseline.pdf.price_summary'})}</TextHeaderSecondary>
			<ViewLine>
				<TextMain bold style={{width: '80%'}}>
					{formatMessage({id: 'common.phase_name'})}
				</TextMain>
				<TextMain bold style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'baseline.pdf.phase_total'})}
				</TextMain>
			</ViewLine>
			{phases
				? phases.map(phase => {
						return <BaselinePDFSummaryPhase key={phase.id} phase={phase} />;
				  })
				: null}
			<ViewLine noBorder>
				<TextMain style={{width: '60%'}}></TextMain>
				<TextTotal style={{textAlign: 'right', width: '20%'}}>
					{formatMessage({id: 'baseline.pdf.grand_total'})}
				</TextTotal>
				<TextTotal style={{textAlign: 'right', width: '20%'}}>{projectTotal}</TextTotal>
			</ViewLine>
		</ViewSection>
	);
};

export default BaselinePDFSummary;
